import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import { ListPaymentConditionsQuery } from '@/core/domain/enterprise/PaymentCondition/PaymentCondition.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { Col } from 'antd';

const PaymentsConditionExtraFilters: React.FC<
  ExtraFiltersProps<ListPaymentConditionsQuery>
> = ({ queryParams, setQueryParams }) => {
  return (
    <Col lg={4} span={24}>
      <OrderExtraFilter
        value={queryParams?.order}
        onChange={(value) =>
          setQueryParams((prev) => ({
            ...prev,
            order: value,
          }))
        }
      />
    </Col>
  );
};

export default PaymentsConditionExtraFilters;
